import BaseNode from "./BaseNode";

/** Noeud de base */
class BaseShortLBO extends BaseNode {
    private _reference: string;
    private _purpose: number;
    private _address: string;
    private _town: string;
    private _postalCode: string;
    private _country: number;

    public constructor(id: string, name: string, invariant: string, objectType: string, location: string, depreciated: boolean, reference: string, purpose: number, address: string, town: string, postalCode: string, country: number) {
        super(id, name, invariant, objectType, location, depreciated);
        this._reference = reference;
        this._purpose = purpose;
        this._address = address;
        this._town = town;
        this._postalCode = postalCode;
        this._country = country;
    }

    /** Référence */
    public get Reference(): string {
        return this._reference;
    }
    public set Reference(value: string) {
        this._reference = value;
    }

    /** Usage */
    public get Purpose(): number {
        return this._purpose;
    }
    public set Purpose(value: number) {
        this._purpose = value;
    }

    /** Adresse */
    public get Address(): string {
        return this._address;
    }
    public set Address(value: string) {
        this._address = value;
    }

    /** Ville */
    public get Town(): string {
        return this._town;
    }
    public set Town(value: string) {
        this._town = value;
    }

    /** Code postal */
    public get PostalCode(): string {
        return this._postalCode;
    }
    public set PostalCode(value: string) {
        this._postalCode = value;
    }

    /** Pays */
    public get Country(): number {
        return this._country;
    }
    public set Country(value: number) {
        this._country = value;
    }
}

export default BaseShortLBO;